import { useExamContext } from "@features/exam/contexts/ExamContext";
import { useStudyPackAccess } from "@hooks/useStudyPackAccess";
import { useMemo } from "react";

export const useActiveStudyPackCollectionId = () => {
	const {
		currentExamContext: { studyPackCollectionId, freeStudyPackCollectionId },
	} = useExamContext();
	const { hasStudyPackPurchaseAccess, isLoading: isStudyPackAccessLoading } =
		useStudyPackAccess();

	const collectionId = useMemo(() => {
		if (isStudyPackAccessLoading) {
			return undefined;
		}

		if (!hasStudyPackPurchaseAccess && freeStudyPackCollectionId) {
			return freeStudyPackCollectionId;
		}

		return studyPackCollectionId;
	}, [
		isStudyPackAccessLoading,
		hasStudyPackPurchaseAccess,
		freeStudyPackCollectionId,
		studyPackCollectionId,
	]);

	return {
		isLoading: isStudyPackAccessLoading,
		collectionId,
		studyPackCollectionId,
		freeStudyPackCollectionId,
	};
};
